import { component } from 'picoapp';
import { addItemById } from '../lib/cart';

export default component((node) => {
  const addToBasketButtons = node.querySelectorAll('.js-add-to-basket');
  
  addToBasketButtons.forEach(button => {
    button.addEventListener('click', function () {
      addItemById(this.dataset.productId);
    });
  });

});